module.exports = __webpack_public_path__ + "static/media/stat520p_pset1.83ad06d5.tex";